module.exports = __webpack_public_path__ + "assets/img/movie.5add52dd.png";